<div>
  <div class="bg-theme p-2 d-flex justify-content-center d-block d-lg-none d-xl-none"> Filters</div>
  <div class="filter-container" >
    <div class="font-11 font-lg-12 font-xl-12" *ngFor="let filter of itemFilters.config; let i = index;">
      <div *ngIf="filter.isVisible && !filter.isValueFilter && !filter.hiddenFilter">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th >{{filter.filterLabel | translate}}</th>
    
            </tr>
          </thead>
          <tbody>
            <tr class="row" *ngIf="!filter.isTemplate">
              <ng-container *ngFor="let rule of filter.rules;">
                <td class="border-0 ps-2 pe-2 pt-0 pb-0 " *ngIf="rule.ids.length">
                  <div class="col-12 d-flex pt-2 pb-2 ps-2 filter-border">
                    <div class="col-7  form-check d-flex align-items-center">
                      <input type="checkbox" (click)="visibleFun()" [(ngModel)]="rule.applied" class="form-check-input p-0"
                        (ngModelChange)="applyFilters(itemFilters, filter, rule)" [disabled]="!rule.ids.length" slot="start"
                        color="medium">
    
                      <label *ngIf="rule.label == 'INV'" class="ms-2 pt-1"
                        (click)="rule.applied = !rule.applied; applyFilters(itemFilters, filter, rule)">
                        {{'LABELS.INVOICES' | translate}}
                      </label>
                      <label *ngIf="rule.label == 'DN'" class="ms-2 pt-1"
                        (click)="rule.applied = !rule.applied; applyFilters(itemFilters, filter, rule)">
                        {{'LABELS.DEBIT_NOTE' | translate}}
                      </label>
                      <label *ngIf="rule.label !== 'DN' && rule.label !== 'INV'" class="ms-2 pt-1"
                        (click)="rule.applied = !rule.applied; applyFilters(itemFilters, filter, rule)">{{rule.label | translate}}
                      </label>
                    </div>
                    <div class="col-5 text-end pe-3">
                      <p class="m-0">
                        <!-- <strong class="frp-label">{{rule[filter.amountProp] | inrdisplay}}</strong> -->
                        <!-- <strong class="sub-header"
                          *ngIf="rule.otherData">{{rule[filter.amountProp] | cpgcurrency: rule.otherData.CURRCODE}}</strong> -->
                        <!--inrdisplay-->
                        <!-- <strong class="sub-header" *ngIf="!rule.otherData">{{rule[filter.amountProp] | inrdisplay}}</strong> -->
                        <!--inrdisplay-->
                        <app-app-currency-display [amtDetails]="rule.amtDetails"></app-app-currency-display>
                      </p>
                      <p class="m-0" style="font-size: 0.5rem;">
                        {{'LABELS.NUMBER_OF_DOCUMENTS' | translate : {noOfDocs: rule.ids.length} }}
    
                      </p>
                    </div>
                  </div>
    
    
                  <div>
                    <span *ngIf="rule.otherData" class="handCursor invInfoContainer" (click)="processOtherDataFn(rule)">
                      <ion-icon class="invInfoCircle" name="information-circle"></ion-icon>
                    </span>
                  </div>
                </td>
              </ng-container>
    
    
            </tr>
            <tr *ngIf="filter.isTemplate && filter.isCreateDate">
    
              <div class="row d-flex align-items-center">
                <div class="col-3">{{ 'LABELS.FROM' | translate}}</div>
                <div class="col-9">
                  <div class="input-group width100">
                    <input class="form-control"  placeholder="DD-MMM-YYYY" name="fromDate"
                      id="fromDate" [(ngModel)]="filterModal.fromCreateDate" ngbDatepicker #fd="ngbDatepicker"
                      #fromDate="ngModel" autocomplete="off" placement="bottom-right" required (dateSelect)="onDateSelection($event)"
                     (click)="fd.toggle()"  [maxDate]="maxDate" (ngModelChange)="applyFiltersForCreateDate(filter.rules[0], 'from')">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" #btnCalendar (click)="fd.toggle()" type="button">
                        <i class="mdi mdi-calendar ms-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row d-flex align-items-center">
                <div class="col-3">{{ 'LABELS.TO' | translate}}</div>
                <div class="col-9">
                  <div class="input-group width100">
                    <input class="form-control"  placeholder="DD-MMM-YYYY" name="toDate"
                      id="toDate" [(ngModel)]="filterModal.toCreateDate" ngbDatepicker #td="ngbDatepicker"
                      #toDate="ngModel" autocomplete="off" placement="bottom-right" required
                      (click)="td.toggle()" [maxDate]="maxDate" [minDate]="minDate" (ngModelChange)="applyFiltersForCreateDate(filter.rules[0], 'to')" >
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" #btnCalendar (click)="td.toggle()" type="button">
                        <i class="mdi mdi-calendar ms-1"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row"
                *ngIf="filter.rules[0] && (filter.rules[0].fromCreateDate || filter.rules[0].toCreateDate) && !filter.rules[0].disabled">
                <div class="col-4">
                </div>
                <div class="col-12">
                  <!-- <a href="javascript:;" (click)="clearCreateDateFilters(filter)">{{'LABELS.CLEAR_DATE' | translate}}</a> -->
                  <a href="javascript:;" (click)="clearCreateDateFilters(filter)">{{'LABELS.CLEAR_DATES' | translate}}</a>
                </div>
              </div>
    
            </tr>
    
          </tbody>
        </table>
      </div>
    </div>
  </div>
 
  <!--Footer for Mobile-->
  <div class="col-12 d-flex pt-2 pb-2 pe-3 ps-3 d-block d-lg-none d-xl-none">
    <div class="col-6">
      <button (click)="resetFilters()" class="btn fis-btn col-10">Reset</button>
    </div>
    <div class="col-6 text-end" *ngIf="!visible">
      <button (click)="close()" class="btn fis-btn col-10">Close</button>
    </div>
    <div class="col-6 text-end" *ngIf="visible">
      <button class="btn fis-btn col-10" (click)="close()">Select</button>
    </div> 
  </div>
</div>


<ng-container *ngIf="!itemFilters.configsVisible">
  <div class="text-center ion-padding">
    <b>{{'LABELS.NO_SEARCH_FILTER_RESULT' | translate}}</b>
    <!-- <div>
      <a href="javascript:;" (click)="clearFilters()">Clear Filters</a>
    </div> -->
  </div>
</ng-container>
